import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualPrestador from '../../actions/prestador/determinarPaginaAtualPrestador'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoPrestador extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualPrestador}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualPrestador,
    total: state.prestadores.total,
    registrosPorPagina: state.registrosPorPaginaPrestador
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualPrestador }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoPrestador)
